<template lang="pug">
  div
    p.title(v-if="title.length") {{ title }}
    v-simple-table
      template(v-slot:default)
        thead(v-if="headers.length")
          tr
            th(v-for="(head,i) in headers" :key="'head'+i") {{ head }}
            th
        tbody
          tr(v-for="(field,j) in createdFields" :key="'field'+j")
            td.py-2 {{ field.key }}
            td.py-2
              v-text-field(v-model="field.value" single-line outlined dense hide-details)
            td.py-2
              v-btn(@click="removeField(field.key)" color="red lighten-2") {{ translations.button.remove }}
          tr
            td.py-2
              v-text-field(v-model="emptyfield.key" :label="translations.label.key" single-line outlined dense hide-details)
            td.py-2
              v-text-field(v-model="emptyfield.value" :label="translations.label.value" single-line outlined dense hide-details)
            td.py-2
              v-btn(@click="addField" color="green lighten-2") {{ translations.button.add }}
          tr(v-if="emptyfield.key != '' || emptyfield.value != ''")
            td.py-2(colspan="3") {{ translations.advise }}
    v-dialog.grey(v-model="dialog" max-width="400")
      v-card
        v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
          span {{ translations.dialog.title }}
          v-btn(@click="dialog = false" icon)
            v-icon mdi-close
        v-card-text
          v-row.text-center
            v-col(cols="12")
              p {{ dialogtext }}
            v-col(cols="12")
              v-btn(@click="dialog = false") {{ translations.dialog.button }}
</template>

<script>
  export default {
    name: "BaseDynamicField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      headers: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data:() => ({
      emptyfield: {
        key: '',
        value: '',
        type: 'text'
      },
      createdFields: [],
      dialog: false,
      dialogtext: '',
    }),
    computed: {
      translations(){
        return this.$t("components.baseDynamicField");
      }
    },
    watch: {
      value: function(val){
        this.createdFields = val;
      }
    },
    created(){
      this.createdFields = this.value;
    },
    methods:{
      addField(){
        const that = this
        if (this.emptyfield.key == ''){
          this.dialogtext = this.translations.dialog.textempty;
          this.dialog = true;
        } else if(this.createdFields.filter(item=>{return item.key == that.emptyfield.key}).length != 0){
          this.dialogtext = this.translations.dialog.textrepeat;
          this.dialog = true;
        } else {
          this.createdFields.push(this.emptyfield);
          this.emptyfield = { key: '', value: '' };
          this.$emit('input', this.createdFields);
        }
      },
      removeField(key){
        for( let i = 0; i < this.createdFields.length; i++){
          if ( this.createdFields[i].key === key) { 
            this.createdFields.splice(i, 1);
            this.$emit('input', this.createdFields);
          }
        }
      },
      clear(){
        this.emptyfield.key = '';
        this.emptyfield.value = '';
      },
    },
  }
</script>

<style lang="sass">
</style>